import { USERS_LIST } from '../Reducers/usersReducer';
import { USERS_UPDATE_ERROR, USERS_UPDATE_LOADING, USERS_UPDATE_SUCCESS } from '../Reducers/usersUpdateReducer';
import { fetchUsers as fetchUsersApi, updateUser as updateUserApi } from '../Util/queries';
import { UsersList } from '../Model/userObjects';

export const getUsers = () => async (dispatch) => {
    try {
        const response = await fetchUsersApi();
        dispatch({ type: USERS_LIST, payload: new UsersList(response.data) });
    } catch (error) {
        console.error('Failed to fetch users:', error);
        dispatch({ type: USERS_LIST, payload: new UsersList() });
    }
};


export const updateUser = (userId, data) => async (dispatch) => {
    dispatch({ type: USERS_UPDATE_LOADING });
    try {
        await updateUserApi(userId, data);
        dispatch(getUsers()).then(() => {
            dispatch({ type: USERS_UPDATE_SUCCESS });
        });
    } catch (error) {
        console.error('Failed to update user:', error);
        dispatch({ type: USERS_UPDATE_ERROR, payload: error.message });
    }
};
